<script setup lang="ts">
import { ref } from 'vue';

interface BreadCrumbItem {
  label: string;
  route?: string;
  icon?: string;
}

interface Props {
  items: BreadCrumbItem[];
}

const props = defineProps<Props>();

const home = ref({
  icon: 'pi pi-home',
  route: '/',
});

</script>

<template>
  <Breadcrumb
    class="mb-3"
    :home="home"
    :model="items"
  >
    <template #item="{ label, item, props }">
      <router-link
        v-if="item.route"
        v-slot="routerProps"
        :to="item.route"
      >
        <a
          :href="routerProps.href"
          v-bind="props.action"
        >
          <span v-bind="props.icon" />
          <span
            class="pl-2"
            v-bind="props.label"
          >{{ label }}</span>
        </a>
      </router-link>
      <span
        v-else
        v-bind="props.action"
      >
        <span v-bind="props.icon" />
        <span
          class="pl-2"
          v-bind="props.label"
        >{{ label }}</span>
      </span>
    </template>
  </Breadcrumb>
</template>
